module.exports = __webpack_public_path__ + "static/media/innov_3.ca59175a.jpg";